import Client from "./Client";
import { OfferReminder } from "./OfferReminder";
import { YousignMember } from "./YousignMember";
export class OfferClient {
  constructor({
    id = Number.NaN,
    client = null,
    contact = null,
    member = null,
    dateUpdated = null,
    dateCreated = null,
    offer = Number.NaN,
    reasonDecline = "",
    status = "PENDING",
    reminders = [],
    yousignLink = null,
    certificate = "",
    email = null,
    action = "",
    order = null,
  } = {}) {
    this.id = Number.parseInt(id);
    this.client = client ? new Client(client) : null;
    this.contact = contact;
    this.member = member ? new YousignMember(member) : null;
    this.dateCreated = dateCreated ? new Date(dateCreated) : null;
    this.dateUpdated = dateUpdated ? new Date(dateUpdated) : null;
    this.status = status;
    this.reasonDecline = reasonDecline;
    this.offer = offer;
    this.reminders = reminders
      ? reminders.map((r) => new OfferReminder({ ...r }))
      : [];
    this.yousignLink = yousignLink;
    this.certificate = certificate;
    this.email = email;
    this.action = action;
    this.order = order;
  }
}
